import {
  Warning as ErrorIcon,
  DeleteForever as DeleteIcon,
} from '@mui/icons-material';
import TonalButton from '@/components/TonalButton';
import { useState } from 'react';
import useDeleteThumbnail from '../ThumbnailControls/DeleteThumbnail/useDeleteThumbnail';
import Dialog from '@/components/Dialog';
import { FormattedMessage } from 'react-intl';
import ErrorStateWrapper from './ErrorStateWrapper';
import FormattedHtmlMessage from '@/components/FormattedHtmlMessage';
import UnsafeFileRetentionWarning from './UnsafeFileRetentionWarning';

type ThumbnailErrorStateProps = {
  variant: 'malware' | 'inappropriate_content';
};

const ThumbnailErrorState = ({ variant }: ThumbnailErrorStateProps) => {
  const [deleteConfirmationDialogOpen, setDeleteConfirmationDialogOpen] =
    useState(false);
  const [deleting, setDeleting] = useState(false);

  const deleteThumbnail = useDeleteThumbnail();

  const handleDeleteThumbnail = async (): Promise<void> => {
    setDeleting(true);
    setDeleteConfirmationDialogOpen(false);

    await deleteThumbnail();

    setDeleting(false);
  };

  return (
    <>
      <ErrorStateWrapper isShowingImage={false}>
        <div>
          <ErrorIcon color="error" />
          <div>
            <h4>
              <FormattedMessage id="portfolio.challenge.thumbnail_header.error_state.title" />
            </h4>
            <p>
              <FormattedMessage
                id={`portfolio.challenge.thumbnail_header.error_state.text.${variant}`}
              />
            </p>
            <TonalButton
              size="small"
              startIcon={<DeleteIcon />}
              onClick={() => setDeleteConfirmationDialogOpen(true)}
              loading={deleting}
              loadingPosition="start"
            >
              <FormattedMessage id="portfolio.challenge.thumbnail_header.error_state.remove_thumbnail.button" />
            </TonalButton>
          </div>
        </div>
      </ErrorStateWrapper>
      <Dialog
        open={deleteConfirmationDialogOpen}
        onClose={() => setDeleteConfirmationDialogOpen(false)}
        dangerous
      >
        <Dialog.Title>
          <FormattedMessage id="portfolio.challenge.thumbnail_header.error_state.remove_thumbnail.confirmation_dialog.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessage id="portfolio.challenge.thumbnail_header.error_state.remove_thumbnail.confirmation_dialog.text" />
          </Dialog.ContentText>
          <UnsafeFileRetentionWarning severity="warning">
            <FormattedHtmlMessage
              id={`portfolio.challenge.thumbnail_header.error_state.remove_thumbnail.confirmation_dialog.error_state_messages.${variant}`}
            />
          </UnsafeFileRetentionWarning>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.CancelButton
            onClick={() => setDeleteConfirmationDialogOpen(false)}
          />
          <Dialog.Actions.DeleteButton onClick={handleDeleteThumbnail} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default ThumbnailErrorState;
